import React from 'react';
import { get } from 'global/lib/lodash';
import useRetrieveData from '../../hooks/useRetrieveData';
import Modal from '../modal';
import Form from '../../components/form';
import { useUser } from '../../hooks/useUser';

export const EditChartModal = (props) => {
  const usergroups = useRetrieveData({ url: `/user-groups` }, { build: ['userGroups'], useCache: { reload: 60 } });
  const { me } = useUser();

  return (
    <Modal {...props}>
      {!!props.open && (
        <Form
          showAllScreens
          onSubmit={(v) => props.onSubmit(v, props)}
          submitText="Submit"
          canSubmit={true}
          submitBtnBoxStyle={{ position: 'relative' }}
          useCheckContinue
          screens={[
            {
              title: '',
              inputs: [
                {
                  id: 'name',
                  title: 'Title',
                  type: 'TextField',
                  defaultValue: () => get(props, 'chart.name', ''),
                  props: {
                    label: 'Title',
                    required: true,
                  },
                },
                {
                  id: 'description',
                  title: 'Description',
                  type: 'TextField',
                  defaultValue: () => get(props, 'chart.description', ''),
                  props: {
                    label: 'Description',
                  },
                },
                {
                  id: 'userGroups',
                  title: 'User Group',
                  type: 'Select',
                  defaultValue: () => get(props, 'chart.userGroups', get(me, 'userGroups', [])).map((u) => `${u.id || u}`),
                  data: () => usergroups.data,
                  item: (d) => ({ title: d.name, value: d.id }),
                  props: {
                    label: 'User Group',
                    multiple: true,
                    required: true,
                  },
                },
                {
                  id: 'realms',
                  type: 'DropRealms',
                  defaultValue: () => (get(props, 'chart.realms', []).find((r) => r.tier === 'division') ? get(props, 'chart.realms', []) : get(props, 'chart.realms', [])),
                  props: {
                    label: 'Access',
                    placeholder: 'Global',
                    useNewHist: true,
                    onlyTiers: ['builder', 'division'],
                    helperText: 'Leave this blank to to make the chart available to all users',
                  },
                },
              ],
            },
          ]}
        />
      )}
    </Modal>
  );
};
